///<reference path="converter.base.ts"/>

module Meevo.Components.Controls.HideInput {

    import ICultureModel = Meevo.Components.Common.ICultureModel;
    import stereographic = d3.geo.stereographic;

    export interface IPhoneConverterOptions {
        cultureModel: ICultureModel;
    }

    export interface IPhoneModelValue {
        countryCode?: string;
        phoneNumber?: string;
    }

    export class PhoneConverter extends ConverterBase implements IStringConverter {

        private _modelValue: IPhoneModelValue;

        constructor(private options: IPhoneConverterOptions) {
            super();

            this._modelValue = {};
        }

        private getOnlyNumbers(str: string) {
            return str.match(/\d/g) || [];
        }

        preUpdateValue(str: string = ''): string {
            if (!this.options.cultureModel || !str) return str;

            if (this.options.cultureModel.testPhone(str)) {
                let mask: string = this.options.cultureModel.phoneNumberMask;
                for (const number of str.match(/\d/g)) {
                    mask = mask.replace('\d', number);
                }

                return mask;
            } else if (this.options.cultureModel.phoneWithCountryCode(str)) {
                const onlyNumbers: string = this.getOnlyNumbers(str).join('');
                const firstNumberRegExp = new RegExp(`^${this.options.cultureModel.countryCode}`);
                const phoneWithoutCountry = onlyNumbers.replace(firstNumberRegExp, '');

                let mask: string = this.options.cultureModel.phoneNumberMask;
                for (const number of phoneWithoutCountry.match(/\d/g)) {
                    mask = mask.replace('\d', number);
                }

                return mask;
            }

            return this.getOnlyNumbers(str).join('');
        }

        hide(str: string = ''): string {
            if (!this.options.cultureModel || !str) return str;

            if (this.options.cultureModel.testPhone(str)) {
                const numbers: string[] = this.getOnlyNumbers(str);
                let mask: string = this.options.cultureModel.phoneNumberMask;
                const availableDelimiters: string[] = [' ', '-'];
                let lastDelimiterIndex: number = -1;

                // looking for the last delimiter
                for (const delimiter of availableDelimiters) {
                    lastDelimiterIndex = mask.lastIndexOf(delimiter);

                    if (lastDelimiterIndex !== -1) break;
                }

                // hide all previous numbers with stars up to the last delimiter
                for (let i = 0; i < numbers.length; i++) {
                    mask = mask.replace('\d', mask.indexOf('\d') < lastDelimiterIndex ? '*' : numbers[i]);
                }

                return mask;
            }

            return super.hide(str);
        }

        valid(str: string = ''): boolean {
            if (!this.options.cultureModel || !str) return false;

            return this.options.cultureModel.testPhone(str);
        }

        modelValue(str: string = ''): { countryCode?: string; phoneNumber?: string; } {
            if (!this.options.cultureModel || typeof str !== 'string') {
                return {
                    countryCode: this.options.cultureModel.countryCode || '1',
                    phoneNumber: ''
                };
            }

            this._modelValue.countryCode = this.options.cultureModel.countryCode;
            this._modelValue.phoneNumber = this.getOnlyNumbers(str).join('');

            return this._modelValue;
        }

        parseModelValue(modelValue: IPhoneModelValue): string {
            if (typeof modelValue !== 'object') {
                console.warn(`Expected modelValue to be object, "${modelValue}" found`);

                return '';
            }

            return this.preUpdateValue(modelValue.phoneNumber);
        }

        isEqual(value1: IPhoneModelValue, value2: IPhoneModelValue): boolean {
            return value1.phoneNumber === value2.phoneNumber;
        }
    }
}
